
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistorOff as ObiBipolar_transistorOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-off.js';
 
 
 

 
 export const ObiBipolar_transistorOff = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-off',
   elementClass: ObiBipolar_transistorOffElement,
   events: {
     
   }
  });
 
 